/**
 * String Hashing Utilities
 *
 * These functions use the djb2 algorithm for simple, fast string hashing.
 * Use these for creating stable identifiers (file paths, component keys, etc.).
 *
 * Note: There's also a `hashString` function in utils.tsx that uses MurmurHash3.
 * MurmurHash3 is more sophisticated but these djb2 functions are sufficient for
 * identifier generation. Use these for consistency with existing identifier patterns.
 */

/**
 * Hash a string to an integer using the djb2 algorithm.
 * Useful for consistent color selection, indexing, etc.
 */
export function hashStringToInt(str: string): number {
  let hash = 5381; // djb2 hash initial value
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 33) ^ str.charCodeAt(i); // djb2 hash algorithm
  }
  return Math.abs(hash);
}

/**
 * Hash a string to a hex string.
 * Useful for creating stable identifiers from strings.
 */
export function hashStringToHex(str: string): string {
  return hashStringToInt(str).toString(16);
}
